import { applyEach, disabled, schema, validate } from '@angular/forms/signals';
import { Produktdaten } from '../../../../generated/model/produktdaten.model';
import { ZaehlerType } from '../../../model/zaehler-typ.model';
import { CustomValidators } from '@shared-ikp/utils/validators';
import { validateWithControlValidator } from '@shared-ikp/utils/signal-forms.util';

export interface ZaehlerSpecsFormValue {
  zaehlerType: ZaehlerType | null;
  zaehlerstand: string | null;
  hasNoZaehlerstand: boolean;
}

export interface ProduktEintragFormValue {
  category: Produktdaten.ProduktEnum | undefined;
  isSelected: boolean;
  zaehlpunktnummer: string;
  zaehlerNr: string | null;
  zaehlerSpecs: ZaehlerSpecsFormValue;
}

export interface ProduktFormValue {
  produkte: ProduktEintragFormValue[];
}

export const produktSchema = schema<ProduktFormValue>(path => {
  applyEach(path.produkte, produkt => {
    disabled(produkt.isSelected, () => true);
    validate(produkt.zaehlerNr, validateWithControlValidator(CustomValidators.meterNumberValidator, 'zaehlerNr'));
    validate(produkt.zaehlerSpecs.zaehlerstand, validateWithControlValidator(CustomValidators.meterCountValidator, 'zaehlerstand'));
  });
});
